import React, { useState, useEffect } from "react";
import "./ReceiptPDFTemplate.scss";
import { getMyClientsByID } from "../../services/api/MyClientsApi";

export const ReceiptPDFTemplate = ({ payment, invoice, settings, isSystemReceipt = false, companyDetails = null }) => {
    console.log(settings, "receipt settings");
    console.log(payment, "payment details");
    console.log(invoice, "invoice details");
    console.log(isSystemReceipt, "isSystemReceipt");
    console.log(companyDetails, "companyDetails");

    const [clientDetails, setClientDetails] = useState(null);
    const [loading, setLoading] = useState(false);

    const {
        headerText,
        header,
        footer,
        displayHeaderFooter,
        displayBankDetails,
        bankDetails,
        isSignatureDigitalGenerated,
        digitalSignature,
        gstNo,
        panNo,
        address,
    } = settings;

    // Updated getDisplayUrl function to handle data URLs
    const getDisplayUrl = (url) => {
        if (!url) return "";
        // Handle data URLs (base64 encoded images)
        if (url.startsWith('data:')) return url;
        // Handle full URLs
        if (url.startsWith('http')) return url;
        // Handle static assets
        if (url.startsWith('/static/') || url.startsWith('/assets/')) return url;
        // Backend paths
        return `${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${url}`;
    };

    // Fetch client details when component mounts - ONLY for regular receipts
    useEffect(() => {
        const fetchClientDetails = async () => {
            // Skip fetching client details for system receipts
            if (isSystemReceipt) {
                return;
            }

            if (invoice?.issuedTo) {
                setLoading(true);
                try {
                    const response = await getMyClientsByID(invoice.issuedTo);
                    setClientDetails(response.data);
                } catch (error) {
                    console.error("Error fetching client details:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchClientDetails();
    }, [invoice?.issuedTo, isSystemReceipt]);

    const formatAmount = (amount) => {
        return amount ? `₹${Number(amount).toFixed(2)}` : "₹0.00";
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('en-IN', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const formatDateTime = (date) => {
        return new Date(date).toLocaleString('en-IN', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <div className="receipt-pdf">
            {displayHeaderFooter ? (
                header ? (
                    <img src={getDisplayUrl(header)} alt="Header" className="receipt-header" />
                ) : (
                    <p>Header not available</p>
                )
            ) : (
                <h2 className="company-name">{headerText}</h2>
            )}

            <div className="receipt-title">
                <h1>PAYMENT RECEIPT</h1>
            </div>

            <div className="receipt-details-container req-pad">
                <div className="receipt-info">
                    <p><strong>Receipt ID:</strong> {payment.recieptId || "N/A"}</p>
                    <p><strong>Receipt Date:</strong> {formatDateTime(payment.paymentDate)}</p>
                    <p><strong>Invoice No:</strong> {invoice?.invoiceNumber || "N/A"}</p>
                    <p><strong>Invoice Date:</strong> {invoice?.createdAt ? formatDate(invoice.createdAt) : "N/A"}</p>
                    {/* Don't show GST and PAN for system receipts */}
                    {!isSystemReceipt && (
                        <>
                            {gstNo && <p><strong>GST No:</strong> {gstNo}</p>}
                            {panNo && <p><strong>PAN No:</strong> {panNo}</p>}
                            {address && <p><strong>Address:</strong> {address}</p>}
                        </>
                    )}
                </div>

                <div className="client-info">
                    {isSystemReceipt ? (
                        // Display company details for system receipts
                        companyDetails ? (
                            <>
                                <p><strong>Company:</strong> {companyDetails.companyName}</p>
                                <p><strong>Address:</strong> {companyDetails.address}</p>
                                {companyDetails.city && <p>{companyDetails.city}, {companyDetails.state} - {companyDetails.zip}</p>}
                                {companyDetails.country && <p>{companyDetails.country}</p>}
                                {companyDetails.email && <p><strong>Email:</strong> {companyDetails.email}</p>}
                                {companyDetails.phone && <p><strong>Phone:</strong> {companyDetails.phone}</p>}
                            </>
                        ) : null
                    ) : (
                        // Display client details for regular receipts
                        loading ? (
                            <p>Loading client details...</p>
                        ) : clientDetails ? (
                            <>
                                <p><strong>Name:</strong> {clientDetails.salutation} {clientDetails.name}</p>
                                <p><strong>Company:</strong> {clientDetails.company}</p>
                                {clientDetails.gstin && <p><strong>GST No:</strong> {clientDetails.gstin}</p>}
                                <p><strong>Address:</strong> {clientDetails.addressLine1}</p>
                                {clientDetails.addressLine2 && <p>{clientDetails.addressLine2}</p>}
                                <p>{clientDetails.city}, {clientDetails.state} - {clientDetails.zipcode}</p>
                                <p>{clientDetails.country}</p>
                            </>
                        ) : (
                            <p>Client details not available</p>
                        )
                    )}
                </div>
            </div>

            <div className="payment-details-section req-pad">
                <h3>Payment Details</h3>
                <table className="payment-details-table">
                    <tbody>
                        <tr>
                            <td><strong>Payment Method:</strong></td>
                            <td>{payment.paymentType}</td>
                        </tr>
                        {payment.paymentType !== "OTHER" && (
                            <tr>
                                <td><strong>Amount Paid:</strong></td>
                                <td className="amount-cell">{formatAmount(payment.amount)}</td>
                            </tr>
                        )}
                        <tr>
                            <td><strong>Payment Date & Time:</strong></td>
                            <td>{formatDateTime(payment.paymentDate)}</td>
                        </tr>
                        {payment.refNumber && (
                            <tr>
                                <td><strong>Reference Number:</strong></td>
                                <td>{payment.refNumber}</td>
                            </tr>
                        )}
                        {payment.chequeNumber && (
                            <tr>
                                <td><strong>Cheque Number:</strong></td>
                                <td>{payment.chequeNumber}</td>
                            </tr>
                        )}
                        {payment.bankName && (
                            <tr>
                                <td><strong>Bank Name:</strong></td>
                                <td>{payment.bankName}</td>
                            </tr>
                        )}
                        {payment.remark && (
                            <tr>
                                <td><strong>Remarks:</strong></td>
                                <td>{payment.remark}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {payment.paymentType !== "OTHER" && (
                <div className="amount-in-words req-pad">
                    <p><strong>Amount in Words:</strong> {convertToWords(payment.amount)} Rupees Only</p>
                </div>
            )}

            {displayBankDetails && bankDetails && (
                <div className="bank-details req-pad">
                    <strong>Bank Details:</strong>
                    <p>{bankDetails}</p>
                </div>
            )}

            <div className="receipt-footer-section req-pad">
                <div className="signature">
                    {isSignatureDigitalGenerated && digitalSignature ? (
                        <img src={getDisplayUrl(digitalSignature)} alt="Digital Signature" />
                    ) : (
                        <p>This is a system-generated receipt</p>
                    )}
                </div>
                
                <div className="generated-info">
                    <p>Generated on: {new Date().toLocaleString('en-IN')}</p>
                    <p>Thank you for your payment!</p>
                </div>
            </div>

            {displayHeaderFooter && footer && (
                <img src={getDisplayUrl(footer)} alt="Footer" className="receipt-footer" />
            )}
        </div>
    );
};

// Helper function to convert numbers to words (basic implementation)
function convertToWords(amount) {
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

    if (!amount || amount === 0) return 'Zero';
    
    const num = Math.floor(Number(amount));
    if (num === 0) return 'Zero';
    
    let result = '';
    
    // Crores
    if (num >= 10000000) {
        const crores = Math.floor(num / 10000000);
        result += convertHundreds(crores) + ' Crore ';
    }
    
    // Lakhs
    const lakhs = Math.floor((num % 10000000) / 100000);
    if (lakhs > 0) {
        result += convertHundreds(lakhs) + ' Lakh ';
    }
    
    // Thousands
    const thousands = Math.floor((num % 100000) / 1000);
    if (thousands > 0) {
        result += convertHundreds(thousands) + ' Thousand ';
    }
    
    // Hundreds
    const hundreds = num % 1000;
    if (hundreds > 0) {
        result += convertHundreds(hundreds);
    }
    
    return result.trim();
    
    function convertHundreds(n) {
        let str = '';
        if (n >= 100) {
            str += ones[Math.floor(n / 100)] + ' Hundred ';
            n %= 100;
        }
        if (n >= 20) {
            str += tens[Math.floor(n / 10)] + ' ';
            n %= 10;
        }
        if (n >= 10) {
            str += teens[n - 10] + ' ';
        } else if (n > 0) {
            str += ones[n] + ' ';
        }
        return str;
    }
}